var _defs, _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSql(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21.7983 20.3124",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.79834,
    height: 20.312378,
    fill: "none",
    customFrame: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "pixso_custom_mask_type_outline"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0 "
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask_0",
    width: 21.797899,
    height: 20.311949,
    x: 0.000732,
    y: 0.000366,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#pixso_custom_mask_type_outline)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62 3555",
    width: 21.797899,
    height: 20.311949,
    x: 0.000732,
    y: 0.000366,
    fill: "rgb(255,255,255)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4 4132"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4 4131",
    mask: "url(#mask_0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84 9929",
    d: "M1.85299 1.67276L4.6738 1.67276C4.72853 1.72629 4.76065 1.75842 4.81538 1.81314L4.86058 5.20263L6.50952 5.20263L6.50952 1.85597C6.51428 1.36819 6.33107 0.906583 6.00271 0.566326C5.66126 0.193946 5.21036 0.00359188 4.68213 2.27401e-05L1.86013 2.27401e-05C1.3664 -0.00235668 0.884567 0.182049 0.540741 0.527065C0.185017 0.87922 -0.0124753 1.367 0.000611563 1.85002L0.000611563 4.82787C0.000611563 5.05392 0.0672354 5.2752 0.190965 5.46318L4.86058 12.5527L4.86058 16.8797C4.8594 16.9689 4.75946 17.0676 4.65952 17.0676L4.65714 17.0676L1.72926 17.0248C1.69238 16.9855 1.67335 16.9344 1.67454 16.8654L1.67454 14.361L0.000611563 14.361L0.000611563 16.8523C-0.00890613 17.3496 0.186207 17.8362 0.525275 18.1776C0.861963 18.5381 1.33309 18.7416 1.81254 18.7416L1.85299 18.7416L4.69521 18.7416C5.18894 18.7308 5.64936 18.5286 5.98962 18.1752C6.33226 17.8243 6.52142 17.3413 6.50952 16.8654L6.50952 12.1684L1.85894 4.95993C1.73759 4.77315 1.67454 4.55543 1.67454 4.33295L1.67454 1.81552C1.67692 1.74533 1.73283 1.65015 1.85299 1.67276Z",
    fill: "rgb(120,138,173)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84 9930",
    d: "M13.6373 0.586545C13.2959 0.222493 12.8069 0.0499851 12.3263 0.0285703L9.51498 0.0285703C9.02006 0.0273806 8.53585 0.208217 8.18488 0.559182C7.83273 0.908957 7.6388 1.39436 7.65308 1.875L7.65308 16.8761C7.64118 17.3698 7.83273 17.8564 8.1706 18.2026C8.51681 18.5714 8.96414 18.7689 9.49832 18.7653L10.813 18.7653L11.1675 20.0252C11.2151 20.1954 11.3709 20.312 11.547 20.312L12.9735 20.312L12.5333 18.7499C12.9437 18.6963 13.3232 18.5119 13.6171 18.2228C13.9752 17.8754 14.1715 17.3888 14.1537 16.913L14.1537 1.88333C14.1608 1.39674 13.9681 0.919664 13.6373 0.586545ZM9.32106 1.8405C9.32343 1.76912 9.40314 1.69774 9.49832 1.69655L12.3394 1.69655C12.4107 1.69893 12.4857 1.78102 12.4821 1.875L12.4821 16.9094C12.4845 16.9594 12.4655 17.0105 12.4274 17.0486L9.49832 17.0926L9.38411 17.0486L9.37459 17.0486C9.33771 17.0105 9.31868 16.9594 9.31987 16.9058L9.32106 1.8405Z",
    fill: "rgb(120,138,173)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84 9931",
    d: "M17.631 17.0676C17.2622 17.0676 16.9624 16.769 16.9612 16.399L16.9386 0L15.2659 0L15.2885 16.8594C15.2897 17.8992 16.1332 18.7415 17.173 18.7415L21.7986 18.7415L21.7986 17.0676L17.631 17.0676Z",
    fill: "rgb(120,138,173)",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSql);
export default __webpack_public_path__ + "static/media/sql.f6c8a9dba8551602326b5f1e4bc43105.svg";
export { ForwardRef as ReactComponent };